const o = {
  styleOverrides: {
    root: ({ theme: e }) => ({
      ...e.typography.body1
    })
  }
};
export {
  o as tableHead
};
//# sourceMappingURL=table.mjs.map
